import { postRequest } from '@/core';
import { savedTripSearches } from '@/requests';

export default async function newSavedTripSearchesRequest(savedSearch) {
	let url = savedTripSearches.getPath();
	let response = await postRequest(url, {},  savedSearch);
	return response;
}
